
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { Identity, ProfileState } from '@/lib/types/identity'
import { ProfileData } from '@/lib/types/api/profile-data'

/**
 * Builds the identity facts from a profile. Pure and synchronous, so it works
 * outside React and unit tests without a renderer.
 */
function buildIdentity(profile: ProfileData): Identity {
  // Defended here rather than at each call site: is_passport is optional, and a
  // degraded profile can arrive without personal_data populated.
  const stations: string[] = profile.personal_data?.stations ?? []
  const isPassport: boolean | undefined = profile.personal_data?.is_passport

  return {
    uid: profile.profile.pid,
    email: profile.profile.email,
    firstName: profile.profile.first_name,
    lastName: profile.profile.last_name,
    thumbnailUrl: profile.profile.thumbnail_url,
    isPassport,
    // Passed through as the raw tri-state. See Identity.vppaAccepted for why
    // this must not be collapsed to a boolean.
    vppaAccepted: profile.profile.vppa_accepted,
    stations,
    isPassportMemberOf(stationData) {
      return isPassport === true && stations.includes(stationData.attributes.call_sign)
    },
  }
}

/**
 * Identity from a confirmed session, or null.
 *
 * Non-null means /sso/profile validated the session. A readable `pbs_uid`
 * cookie is not sufficient, since it can be present for a dead session and
 * absent for a live one.
 */
export function identityFromProfileState(state: ProfileState): Identity | null {
  if (state.status !== 'authenticated') return null

  return buildIdentity(state.profile)
}

/**
 * Identity from whatever profile we hold, confirmed or not.
 *
 * Non-null whenever there is profile data at all, including a localStorage
 * cache while a refresh is in flight. For display and analytics only; it is
 * not an authorization signal.
 */
export function cachedIdentityFromProfileState(state: ProfileState): Identity | null {
  return state.profile ? buildIdentity(state.profile) : null
}
